import { A } from '@adornis/base/env-info.js';
import type { Maybe } from '@adornis/base/utilTypes.js';
import { DataLoadedField } from '@adornis/baseql/decorators/data-loaded-field.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';
import { ChancenwerkUser } from '@chancenwerk/shared/master-data-management/users/entities/ChancenwerkUser.js';
import type { Weekday } from '@chancenwerk/enums/enums.js';
import { DateTime } from 'luxon';
import { MarktAkquiseContactRecord } from './MarktAkquiseContactRecord.js';

/**
 * @entity MarktVeranstaltungsAkquiseEntry
 */
@Entity()
export class MarktVeranstaltungsAkquiseEntry extends AdornisEntity {
  public static override _class = 'MarktVeranstaltungsAkquiseEntry';

  public static override resolveID(entity: any): string {
    return entity._id ?? A.getGloballyUniqueID();
  }

  @Field(() => String, { default: v => v ?? A.getGloballyUniqueID() })
  _id: Maybe<string>;

  @Field(() => String)
  semester: Maybe<string>;

  @Field(() => String)
  name: Maybe<string>;

  @Field(() => String)
  room: Maybe<string>;

  @Field(() => [String])
  days: Maybe<Weekday[]>;

  @Field(() => DateTime)
  startTime: Maybe<DateTime>;

  @Field(() => DateTime)
  endTime: Maybe<DateTime>;

  @Field(() => DateTime)
  start: Maybe<DateTime>;

  @Field(() => DateTime)
  end: Maybe<DateTime>;

  @Field(() => String)
  contactPersonID: Maybe<string>;

  @DataLoadedField(() => ChancenwerkUser, ({ contactPersonID }) => contactPersonID)
  contactPerson: Maybe<ChancenwerkUser>;

  @Field(() => [MarktAkquiseContactRecord])
  contacts: Maybe<MarktAkquiseContactRecord[]>;

  getLatestStatus() {
    return this.contacts?.at(-1)?.status ?? ('Leer' as string);
  }
}
